import { Injectable } from '@angular/core';

export function normalizeHexColor(color: string | undefined | null): string {
  if (!color) {
    return '';
  }

  const trimmed = color.trim();
  if (!trimmed) {
    return '';
  }

  if (trimmed.startsWith('#')) {
    return trimmed;
  }

  if (/^[0-9a-fA-F]{3}([0-9a-fA-F]{3})?$/.test(trimmed)) {
    return `#${trimmed}`;
  }

  return trimmed;
}

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  normalizeHexColor(color: string | undefined | null): string {
    return normalizeHexColor(color);
  }

  capitalizeFirstLetter(str: string): string {
    if (!str) return '';
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  calculateTimeToBookingOpen(startDateTime: string, bookingOpensInMinutes: number): {
    isOpen: boolean;
    timeLeft: number;
    formattedTimeLeft: string;
  } {
    if (bookingOpensInMinutes === 0) {
      return {
        isOpen: true,
        timeLeft: 0,
        formattedTimeLeft: ''
      };
    }

    const now = new Date();
    const startTime = new Date(startDateTime);
    const bookingOpenTime = new Date(startTime.getTime() - (bookingOpensInMinutes * 60 * 1000));
    const timeLeft = bookingOpenTime.getTime() - now.getTime();
    const isOpen = timeLeft <= 0;

    return {
      isOpen,
      timeLeft,
      formattedTimeLeft: this.formatTimeLeft(timeLeft)
    };
  }

  private formatTimeLeft(timeLeft: number): string {
    if (timeLeft <= 0) return '';

    const seconds = Math.floor((timeLeft / 1000) % 60);
    const minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

    // Check if we're on mobile
    const isMobile = window.innerWidth <= 768;

    if (days > 0) {
      if (isMobile) {
        return `${days}d ${this.padNumber(hours)}h`;
      }
      return `${days}d ${this.padNumber(hours)}:${this.padNumber(minutes)}:${this.padNumber(seconds)}`;
    }
    
    if (isMobile) {
      if (hours > 0) {
        return `${this.padNumber(hours)}:${this.padNumber(minutes)}`;
      }
      return `${this.padNumber(minutes)}:${this.padNumber(seconds)}`;
    }
    return `${this.padNumber(hours)}:${this.padNumber(minutes)}:${this.padNumber(seconds)}`;
  }

  private padNumber(num: number): string {
    return num.toString().padStart(2, '0');
  }
} 